///include /assets/js/app/p/checkout-info.js

class PaymentInfoCapture {
    static get drivers() {
        if(!this._drivers) {
            /**
             * @type {{[type: string]: typeof PaymentInfoCaptureDriver}}
             */
            this._drivers = {}
        }
        return this._drivers
    }
    /**
     * @param {?string} return_url
     * @param {?string} failureReason
     * @param {boolean} from_vue
     */
    static async init(return_url = null, failureReason = null, from_vue = true) {
        for(const d of Object.values(this.drivers)) {
            d.init(return_url, failureReason, from_vue)
        }
    }
    /**
     * @param {HTMLFormElement} pf
     */
    static async initForm(pf) {
        for(const d of Object.values(this.drivers)) {
            d.initForm(pf)
        }
    }
    /**
     * @param {string} type
     * @param {typeof PaymentInfoCaptureDriver} driver
     */
    static register(type, driver) {
        this.drivers[type] = driver
    }
}

class PaymentInfoCaptureDriver {
    static get pgDrivers() {
        if(!this._pgDrivers) {
            /**
             * @type {{[type: string]: typeof PaymentInfoCapturePGDriver}}
             */
            this._pgDrivers = {}
        }
        return this._pgDrivers
    }
    /**
     * @type {string}
     */
    static get infoType() {
        throw new Error("Not implemented")
    }
    /**
     * @type {string}
     */
    static get type() {
        throw new Error("Not implemented")
    }
    /**
     * @param {typeof PaymentInfoCapturePGDriver} d
     */
    static addDriver(d) {
        this.pgDrivers[d.type] = d
    }
    /**
     * @return {Promise<PaymentInfoCapturePGDriver|null|undefined>}
     */
    static async getDriver() {
        if(this.driver === undefined) {
            const info = await CheckoutInfo.inst.preloadSingle("info")
            if(this.driver) return this.driver
            if(info[this.infoType]) {
                const c = this.pgDrivers[info[this.infoType].type]
                if(c) {
                    /** @type {PaymentInfoCapturePGDriver|null} */
                    this.driver = new c()
                } else {
                    console.error(`No driver for ${info[this.infoType].type}`)
                    this.driver = null
                }
            } else {
                this.driver = null
            }
        }
        return this.driver
    }
    /**
     *
     * @param {?string} return_url
     * @param {?string} failureReason
     * @param {boolean} from_vue
     */
    static async init(return_url = null, failureReason = null, from_vue = true) {
        if(failureReason == "declined") {
            const dm = document.querySelector("#declined-message")
            if(dm instanceof HTMLElement) {
                dm.style.display = ""
            } else {
                console.error(
                    "Declined but notification element is missing"
                )
            }
        }
        const driver = await this.getDriver()
        if(driver) {
            driver.init(return_url, from_vue)
        }
    }
    /**
     * @param {HTMLFormElement} pf
     */
    static async initForm(pf) {
        const driver = await this.getDriver()
        if(driver) {
            await driver.initForm(pf)
        }
    }
}

class PaymentInfoCapturePGDriver {
    /**
     * @type {string}
     */
    static get type() {
        throw new Error("Not implemented")
    }
    get canCapture() {
        return true
    }
    /**
     *
     * @param {?string} return_url
     * @param {boolean} [from_vue]
     */
    init(return_url = null, from_vue = true) {
        throw new Error("Not implemented")
    }
    /**
     * @param {HTMLFormElement} pf
     */
    async initForm(pf) {
        throw new Error("Not implemented")
    }
    /**
     * @param {?string} currency
     * @returns {Promise<boolean>}
     */
    async startAdd(currency) {
        return true
    }
    async submitForm() {
        throw new Error(
            `Cannot submit form for non-supported capture provider`
        )
    }
}